




































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { TransportLoadTransportPart } from "../models";

class PartModel {
    hourValues = [0, 1, 2, 3, 4, 5, 6];
    minuteValues = [0, 15, 30, 45];

    readonly label1: string;
    readonly label2: null | string = null;

    value1Value: number;
    value2Value: null | number = null;

    get value1(): number { return this.value1Value; }
    set value1(v: number) {
        this.value1Value = v;
        this.loadTransportPart.value = this.value;
    }

    get value2(): null | number { return this.value2Value; }
    set value2(v: null | number) {
        this.value2Value = v;
        this.loadTransportPart.value = this.value;
    }

    get type() {
        return this.loadTransportPart.type;
    }

    get value() {
        if (this.loadTransportPart.type === "TIME") {
            return this.value1 + this.value2! / 60.0;
        } else {
            return this.value1;
        }
    }

    get description() {
        return this.loadTransportPart.description;
    }

    get details() {
        if (this.loadTransportPart.cityFrom || this.loadTransportPart.cityTo) {
            return `${this.loadTransportPart.cityFrom} - ${this.loadTransportPart.cityTo}`;
        }

        return null;
    }

    constructor(public loadTransportPart: TransportLoadTransportPart) {
        const value = this.loadTransportPart.value || 0;

        if (this.loadTransportPart.type === "TIME") {
            this.value1Value = Math.floor(value);
            this.label1 = "h";
            this.value2Value = Math.round((value - Math.floor(value)) * 60);
            this.label2 = "m";
        } else if (this.loadTransportPart.type === "TRANSITION") {
            this.value1Value = value;
            this.label1 = "km";
        } else {
            this.value1Value = value;
            this.label1 = (this.loadTransportPart.type || "").toLowerCase();
        }
    }
}

@Component
export default class LoadTransportPartEdit extends Vue {
    @Prop() parts!: TransportLoadTransportPart[];

    model: null | PartModel[] = null;

    mounted() {
        this.model = this.parts
            .filter(p => p.driverEditable)
            .map(p => new PartModel(p));
    }
}
